import Reader from "./shift-reader";
import Expander from "./expander";
import {List} from "immutable";
import Syntax from "./syntax";
import Env from "./env";
import reduce from "shift-reducer";
import ParseReducer from "./parse-reducer";
import codegen, {FormattedCodeGen} from "shift-codegen";
import {Scope, freshScope} from "./scope";
import BindingMap from "./binding-map.js";
import Term from "./terms";
import {Modules} from "./modules";
export function expand(source_620, options_621 = {}) {
  let reader_622 = new Reader(source_620);
  let stxl_623 = reader_622.read();
  let scope_624 = freshScope("top");
  let bindings_625 = new BindingMap;
  let expander_626 = new Expander({env: new Env, store: new Env, bindings: bindings_625, cwd: options_621.cwd, filename: options_621.filename, modules: new Modules, currentScope: [scope_624], transform: options_621.transform ? options_621.transform : function (x_628) {
    return {code: x_628};
  }, moduleResolver: options_621.moduleResolver, moduleLoader: options_621.moduleLoader});
  let exStxl_627 = expander_626.expand(stxl_623.map(s_629 => s_629.addScope(scope_624, bindings_625)));
  return new Term("Module", {directives: List(), items: exStxl_627});
}
export function parse(source_630, options_631 = {}) {
  return reduce(new ParseReducer, expand(source_630, options_631));
}
export function compile(source_632, options_633 = {}) {
  let ast_634 = parse(source_632, options_633);
  let gen_635 = codegen(ast_634, new FormattedCodeGen);
  return options_633.transform && !options_633.noBabel ? options_633.transform(gen_635, {babelrc: true, filename: options_633.filename}) : {code: gen_635};
}
